export enum ChatbotRole {
  USER = 'USER',
  AGENT = 'AGENT',
}
